/* eslint-disable */
import axios from 'axios'

// Módulo para enviar emails con datos de las reservas
const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/'

const state = {
    sendgrid_data: [],
}

const actions = {
    async sendEmails({
            commit
        },
        date) {
        await axios
            .get(baseUrl + `mails/send_emails/?day=${date}`)
            .then(r => r.data)
            .then(sendgrid_data => {
                commit('SET_SENDGRID_DATA', sendgrid_data)
            })
    },
}

const mutations = {
    SET_TREKKSOFT_DATA(state, sendgrid_data) {
        state.sendgrid_data = sendgrid_data
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}